/**
 * @file
 * Adapted -- Simple Accessible Accordion.
 *
 * @see https://codepen.io/svinkle/pen/mKfru
 */

(function accordionAtomScript($, Drupal, window, once) {
  'use strict';

  let sectionCounter = 0;

  /**
   * Save item focus.
   */
  function saveFocus($label, $section) {
    // Reset other tab attributes.
    $section.find('.js-accordion__item-label').not($label).get().forEach((otherLabel) => {
      $(otherLabel).attr({
        tabindex: '-1',
        'aria-selected': 'false',
      });
    });

    // Set this tab attributes.
    $label.attr({
      tabindex: '0',
      'aria-selected': 'true',
    });
  }

  // Determine if only one item should show at a time.
  function getShowOnlyOneOpenItem($section) {
    const val = $($section).data('accordionOnlyOneOpenItem');
    if (typeof val !== 'undefined' && val !== null) {
      return !!val;
    }

    return false;
  }

  /**
   * Show item body on click.
   */
  function showItemBody(labelElement) {
    const $label = $(labelElement);
    const $body = $label.next();
    const $section = $label.closest('.js-accordion__section');
    const showOnlyOneOpenItem = getShowOnlyOneOpenItem($section);

    // Save focus.
    saveFocus($label, $section);

    // Set this tab attributes.
    if ($body.hasClass('js-accordion__item-body--active')) {
      // Hide body.
      $label
        .attr('aria-expanded', 'false')
        .removeClass('js-accordion__item-label--active');
      $body
        .attr('aria-hidden', 'true')
        .removeClass('js-accordion__item-body--active');
    } else {
      if (showOnlyOneOpenItem) {
        // Hide all items.
        $section.find('.js-accordion__item-body--active')
          .removeClass('js-accordion__item-body--active')
          .attr('aria-hidden', 'true');
        $section.find('.js-accordion__item-label--active')
          .removeClass('js-accordion__item-label--active')
          .attr('aria-expanded', 'false');
      }

      // Show this body.
      $label
        .attr('aria-expanded', 'true')
        .addClass('js-accordion__item-label--active');

      $body
        .attr('aria-hidden', 'false')
        .addClass('js-accordion__item-body--active');
    }
  }

  /**
   * Keyboard interaction.
   */
  function keyboardInteraction(e) {
    const labelElement = e.currentTarget;
    const $label = $(labelElement);

    const nextLabel = $label.parent().next().children(':first-child').is('dt') ? $label.parent().next().children('dt') : false;
    const previousLabel = $label.parent().prev().children(':first-child').is('dt') ? $label.parent().prev().children('dt') : false;
    const firstLabel = $label.parent().siblings().first().find('dt');
    const lastLabel = $label.parent().siblings().last().find('dt');

    switch (e.key) {
      // Left/Up.
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        e.stopPropagation();

        // Check for previous label.
        if (!previousLabel) {
          // No previous, set focus on last label.
          lastLabel.focus();
        } else {
          // Move focus to previous label.
          previousLabel.focus();
        }
        break;

      // Right/Down.
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        e.stopPropagation();

        // Check for next label.
        if (!nextLabel) {
          // No next, set focus on first label.
          firstLabel.focus();
        } else {
          // Move focus to next label.
          nextLabel.focus();
        }
        break;

      // Home.
      case 'Home':
        e.preventDefault();
        e.stopPropagation();

        // Set focus on first label.
        firstLabel.focus();
        break;

      // End.
      case 'End':
        e.preventDefault();
        e.stopPropagation();

        // Set focus on last label.
        lastLabel.focus();
        break;

      // Enter/Space
      case 'Enter':
      case ' ':
        e.preventDefault();
        e.stopPropagation();

        // Show body content.
        showItemBody($label);
        break;

      default:
        break;
    }
  }

  function labelClickListener(event) {
    showItemBody(event.currentTarget);
  }

  function labelFocusListener(event) {
    const $label = $(event.currentTarget);
    saveFocus($label, $label.closest('.js-accordion__section'));
  }

  /**
   * Initialize the widget for the given context.
   */
  function init(context) {
    const sections = once('themeAccordionMolecule', '.js-accordion__section', context);
    if (!sections.length) {
      return;
    }

    sections.forEach((section) => {
      const $section = $(section);
      let sectionId = $section.attr('id');
      const multiselectable = getShowOnlyOneOpenItem($section) ? 'false' : 'true';

      sectionCounter++;
      if (typeof sectionId === 'undefined' || sectionId === null) {
        sectionId = `js-accordion__section--${sectionCounter}${(Math.floor(Math.random() * 10000) + 1)}`;
      }

      // Section.
      $section.attr({
        role: 'tablist',
        'aria-multiselectable': multiselectable,
      });

      // Items.
      $section.find('.js-accordion__item').get().forEach((item, itemIndex) => {
        const $item = $(item);
        const $label = $item.find('.js-accordion__item-label').first();
        const $body = $item.find('.js-accordion__item-body').first();

        // Body.
        $body.attr({
          id: `js-accordion__item-body--${sectionId}--${itemIndex}`,
          role: 'tabpanel',
          'aria-labelledby': `js-accordion__item-label--${sectionId}--${itemIndex}`,
          'aria-hidden': 'true',
        });

        // Label.
        $label.attr({
          id: `js-accordion__item-label--${sectionId}--${itemIndex}`,
          role: 'tab',
          'aria-controls': `js-accordion__item-body--${sectionId}--${itemIndex}`,
          'aria-expanded': 'false',
          'aria-selected': 'false',
          tabindex: '-1',
        });

        // Make first tab clickable.
        if (itemIndex === 0) {
          $label.attr('tabindex', '0');
        }

        // Click event.
        $label.on('click', labelClickListener);

        // Keyboard events.
        $label.on('keydown', keyboardInteraction);

        // Focus.
        $label.on('focus', labelFocusListener);
      });
    });
  }

  // Behaviors.
  Drupal.behaviors.themeAccordionMolecule = {
    attach(context) {
      init(context);
    },
  };
}(jQuery, Drupal, window, once));
